import { createApiSlice } from "@common";
import {
  CURD_CONTACT_TYPE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addContactType",
    method: "post",
    url: CURD_CONTACT_TYPE,
    stateKey: "message",
  },
  {
    name: "getContactType",
    method: "get",
    url: CURD_CONTACT_TYPE,
    stateKey: "data",
  },
  {
    name: "updateContactType",
    method: "put",
    url: CURD_CONTACT_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteContactType",
    method: "delete",
    url: CURD_CONTACT_TYPE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "contactType",
  apiConfig,
  customReducers,
);
const contactTypeSlice = slice;
// Export the slice's reducer
export default contactTypeSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addContactType,
  getContactType,
  updateContactType,
  deleteContactType
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
